import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import * as z from "zod";

export const getRedoSuppliesOrderFulfillmentGroups = {
  name: "getRedoSuppliesOrderFulfillmentGroups" as const,
  input: z.object({ orderId: z.string() }),
  output: z.object({ fulfillmentGroups: z.array(FulfillmentGroupDataSchema) }),
};
